import {
  useClientesFinales,
  useMisClientesFinales,
} from "@/hooks/clientes-finales/useClientesFinales";
import type { ClientesResponse } from "@/hooks/clientes-finales/useClientesFinales";

export type ClientesFinalesScope = "all" | "owned";

export type ClientesFinalesHookResult = ReturnType<typeof useClientesFinales>;

export interface ClientesFinalesScopeConfig {
  title: string;
  buttonLabel: string;
  buildColumnsKey: (
    page: number,
    limit: number,
    search: string
  ) => ReadonlyArray<unknown>;
  queryInvalidateKey: ReadonlyArray<unknown>;
  useClientes: (page: number, limit: number, search: string) => {
    data?: ClientesResponse;
    isLoading: boolean;
    isFetching: boolean;
  };
}

export const CLIENTES_FINALES_SCOPE_CONFIG: Record<
  ClientesFinalesScope,
  ClientesFinalesScopeConfig
> = {
  all: {
    title: "Clientes Finales",
    buttonLabel: "+ Registrar Cliente Final",
    buildColumnsKey: (page, limit, search) => [
      "clientesFinales",
      page,
      limit,
      search,
    ],
    queryInvalidateKey: ["clientesFinales"],
    useClientes: useClientesFinales,
  },
  owned: {
    title: "Clientes Finales",
    buttonLabel: "+ Registrar Cliente Final",
    buildColumnsKey: (page, limit, search) => [
      "misClientesFinales",
      search,
      page,
      limit,
    ],
    queryInvalidateKey: ["misClientesFinales"],
    useClientes: useMisClientesFinales,
  },
};

export function getClientesFinalesScopeConfig(
  scope: ClientesFinalesScope
): ClientesFinalesScopeConfig {
  const config = CLIENTES_FINALES_SCOPE_CONFIG[scope];
  if (!config) {
    throw new Error(`Unknown clientes finales scope "${scope}".`);
  }
  return config;
}

